import { IconProps } from "../IconProps";

export const ArrowLeftIcon = ({ height = 16, width = 16, color = "#333" }: IconProps) => (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.0111 14L5.40838 9.05996C5.14689 8.77924 5 8.39855 5 8.0016C5 7.60466 5.14689 7.22396 5.40838 6.94324L10.0139 2L11 3.05836L6.39729 8.0016L11 12.9416L10.0111 14Z"
            fill={color}
        />
    </svg>
);